import { Platform } from "react-native"

import { observer } from "mobx-react-lite"
import { SidekickNameT } from "types/avatar"
import { EskTypeT, SponsorT } from "types/sponsor"

import { useChat } from "src/context/ChatContext"
import { useOptionalSidekickProgress } from "src/context/SidekickProgressContext"
import { useTyping } from "src/context/TypingContext"
import { useWebLayoutConstraints } from "src/hooks/useWebLayoutConstraints"
import { useStores } from "src/models"
import { useCurrentConversation } from "src/queries/useConversation"
import { MessageBubble } from "./MessageBubble"
import { ThinkingIndicator } from "./ThinkingIndicator"

export const TypingIndicator = observer(() => {
  const {
    typingStore: { incomingMessage },
  } = useStores()
  const { canvasWidth } = useWebLayoutConstraints()

  const { awaitingUserSentence, awaitingESKResponse } = useTyping()
  const { waitingForWelcomeMessage, isSwitchingSidekick, startConversationStatus } = useChat()
  const { data: currentConversation } = useCurrentConversation()
  const { isProgressVisible } = useOptionalSidekickProgress() ?? { isProgressVisible: false }
  const activeESKSponsor = currentConversation?.active_esk_sponsor as SponsorT
  const activeESKType = currentConversation?.active_esk_type as EskTypeT
  const activeSidekickName = currentConversation?.sidekick_name as SidekickNameT
  // FIXME: TypingIndicator can instead return ThinkingIndicator or MessageBubble.
  // These should be correctly determined in the parent that's rendering the chat
  // and shouldn't require branching in this component.
  if (awaitingUserSentence) {
    return <ThinkingIndicator isUser />
  } else if ((incomingMessage || "").length > 0) {
    return (
      <MessageBubble
        overrideText={incomingMessage}
        item={{
          active_esk_sponsor: activeESKSponsor,
          active_esk_type: activeESKType,
          sidekick_name: activeSidekickName,
        }}
        typingIndicator={true}
        containerWidth={Platform.OS === "web" ? canvasWidth : undefined}
      />
    )
  } else if (
    !isProgressVisible &&
    (awaitingESKResponse ||
      waitingForWelcomeMessage ||
      isSwitchingSidekick ||
      startConversationStatus?.isPending)
  ) {
    return <ThinkingIndicator />
  } else {
    return <></>
  }
})
